export type SurveysBetaStatusFilter = 'all' | 'live' | 'draft' | 'complete';

export type SurveysBetaTypeFilter = 'all' | 'web' | 'ai' | 'rtr';

export const SURVEYS_BETA_STATUS_OPTIONS: Array<{
  value: SurveysBetaStatusFilter;
  label: string;
}> = [
  { value: 'all', label: 'All' },
  { value: 'live', label: 'Live' },
  { value: 'draft', label: 'Draft' },
  { value: 'complete', label: 'Complete' },
];

export const SURVEYS_BETA_TYPE_OPTIONS: Array<{
  value: SurveysBetaTypeFilter;
  label: string;
}> = [
  { value: 'all', label: 'All types' },
  { value: 'web', label: 'Web' },
  { value: 'ai', label: 'AI' },
  { value: 'rtr', label: 'RTR' },
];

export const SURVEYS_BETA_PAGE_SIZE = 25;

/** Map UI segmented status → Surveys API `survey_status` CSV values. */
export function statusFilterToApiStatuses(
  filter: SurveysBetaStatusFilter
): string[] | undefined {
  if (filter === 'all') {
    return undefined;
  }
  return [filter];
}

export function parseStatusFilter(raw: string | null): SurveysBetaStatusFilter {
  if (raw === 'live' || raw === 'draft' || raw === 'complete') {
    return raw;
  }
  return 'all';
}

export function parseTitleFilter(raw: string | null): string {
  return (raw || '').trim();
}

export function parseTypeFilter(raw: string | null): SurveysBetaTypeFilter {
  if (raw === 'web' || raw === 'ai' || raw === 'rtr') {
    return raw;
  }
  return 'all';
}

/** Map UI type filter → Surveys API `survey_type` CSV values. */
export function typeFilterToApiTypes(
  filter: SurveysBetaTypeFilter
): string[] | undefined {
  if (filter === 'all') {
    return undefined;
  }
  return [filter];
}
